declare global {
  interface Array<T> {
    distinct(): T[];

    distinct<K>(keySelector: (item: T) => K): T[];

    orderBy<K>(keySelector: (item: T) => K): T[];


  }
}

Array.prototype.orderBy = function <T, K>(
  keySelector: (item: T) => K,
): T[] {
  return [...this].sort((a, b) => {
    const ka = keySelector(a);
    const kb = keySelector(b);

    if (ka < kb) return -1;
    if (ka > kb) return 1;
    return 0;
  });
};
Array.prototype.distinct = function <T, K>(
  keySelector: (item: T) => K = (x) => x as unknown as K,
): T[] {
  const seen = new Set<K>();
  return this.filter((item: T) => {
    const key = keySelector(item);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

export {};

